import { render, staticRenderFns } from "./suitch-props-widget.vue?vue&type=template&id=2e6c7fc2&"
import script from "./suitch-props-widget.vue?vue&type=script&lang=js&"
export * from "./suitch-props-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports